import { BitrixVue } from "ui.vue";

BitrixVue.component("ConfirmBlock", {
  methods: {
    isShowBlock() {
      return this.$store.state.basket.length > 0;
    },
    saveBasket() {
      const context = this;
      let req = BX.ajax.runComponentAction(
        "mworks:configurator",
        "saveBasket",
        {
          mode: "class",
          method: "post",
          data: { basket: this.$store.state.basket },
        }
      );
      req.catch(function (response) {});
      req.then((response) => {
        if (response.status == "success") {
          // this.$store.dispatch('setPosition', {});
          // this.$store.dispatch('setBasketPos', []);

          if (document.querySelector("input[name='form_hidden_51']")) {
            document.querySelector("input[name='form_hidden_51']").value =
              response.data.result.SPEC;
          }
          document.body.insertAdjacentHTML(
            "afterbegin",
            `<input type='hidden' name='jsonspec' value='${response.data.result.SPEC}'/>`
          );
        }
      });
    },
  },
  props: ["totalAmount"],
  template: `
<div class="confirm-block" v-if="isShowBlock()">
    <div class="confirm-block__price">Итоговая стоимость: <span>{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(totalAmount)}}</span></div>
    <div  data-event="jqm" data-param-form_id="CONFIGURATOR" data-name="callback" class="confirm-block__btn confirm-block__btn-order" @click="saveBasket()">Оформить заказ</div>
</div>
`,
});
